import type { JSX } from 'react';

import Palette from 'DesignSystem2/Theme/Palette';
import Emphasis from 'DesignSystem3/Text/Emphasis';
import { toVariableLengthFloat } from 'utils/caseing';

import { AnimatedProjectionText } from './AnimatedProjectionText';

interface ProjectionChangeTextProps {
    change: number;
    text?: string;
    color?: string;
    numberScrollAnimation: boolean;
    fixedLength: boolean;
}

export const getProjectionArrow = (change?: number) => (!change ? '' : change > 0 ? '▲' : '▼');

export const getProjectionChangeTextColor = (change?: number) =>
    !!change && change < 0 ? Palette.Critical.x10 : Palette.Green.x10;

const ProjectionChangeText = ({
    change,
    text,
    color,
    numberScrollAnimation,
    fixedLength,
}: ProjectionChangeTextProps): JSX.Element => {
    const textColor = !!color ? color : getProjectionChangeTextColor(change);
    let changeText = text || (change !== 0 ? `${toVariableLengthFloat(Math.abs(change), 2, fixedLength ? 2 : 0)}` : '');

    if (changeText[0] === '-') {
        changeText = changeText.slice(1);
    }

    return (
        <Emphasis.x20 style={{ color: textColor }} key={'delta-' + textColor}>
            <div className="flex gap-[3.5px]">
                {getProjectionArrow(change)}{' '}
                <AnimatedProjectionText
                    text={changeText}
                    fontSize="13px"
                    numberScrollAnimation={numberScrollAnimation}
                />
            </div>
        </Emphasis.x20>
    );
};

export default ProjectionChangeText;
